import { render, staticRenderFns } from "./AdmissionTestResult.vue?vue&type=template&id=0bc8f801&scoped=true&"
import script from "./AdmissionTestResult.vue?vue&type=script&lang=js&"
export * from "./AdmissionTestResult.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionTestResult.vue?vue&type=style&index=0&id=0bc8f801&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8f801",
  null
  
)

export default component.exports